import React from "react";
import MuiMenu from "@mui/material/Menu";
import { getState, aCreators } from "./reducer";
import { useDispatch, useSelector } from "react-redux";
import { holder } from "./saga";


export const CtxMenuRootComp = React.memo(() => {
  const dispatch = useDispatch();

  const pos = useSelector(s => getState(s).pos);
  const handleClose = React.useCallback(() => (
    dispatch( aCreators.requestToHide() )
  ), [ dispatch ]);

  return (
    <MuiMenu
      keepMounted
      open={pos !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        pos === null
          ? undefined
          : { top: pos.coordinates.top, left: pos.coordinates.left }
      }
      transformOrigin={pos === null ? undefined : pos.transformOrigin}
      MenuListProps={ holder.menuListStyle ? { style: holder.menuListStyle } : undefined }
      {...holder.propsOverride}
    >
      { holder.node }
    </MuiMenu>
  );
});
CtxMenuRootComp.displayName = "redux/contextMenu/Comp";
